import { PdfHeader } from "../../../../components";
import dayjs from "dayjs";
import { formatPhoneNumber, formatAmount } from "../../../../utils/appUtils";
import { cancelConsultationIcon, completeConsultationIcon, consultationAmountIcon, gstIcon, lawyerFees, refundIcon, revenueIcon, totalConsultationIcon, upcomingConsultationIcon } from "../../../../assets/images";
import closeIcon from "../../../../assets/images/close.svg";

const ConsultationMonitoringReport = ({ data, fromDate, toDate, activeTab, consultationMonitoring, month, year, minFilter, searchFilter }) => {

    return <div className="consultationMonitoring-report">
        <PdfHeader pdfName={activeTab === "COMPLETED" ? "Completed Consultation Report" : activeTab === "PENDING" ? "Upcoming Consultation Report" : activeTab === "CANCELLED" ? "Cancelled Consultation Report" : activeTab === "AUTO_CANCELLED" ? "Auto Cancelled Consultation Report" : "Low Rating Consultation Report"} fromDate={fromDate} toDate={toDate} selectedMonth={month} year={year} minFilter={minFilter} searchFilter={searchFilter} />
        <div style={{ padding: "12px 15px", width: "100%", overflow: "hidden" }}>
            <div className="d-flex gap-1 w-100 flex-nowrap align-items-start">
                <div className="consultation-card">
                    <div className="d-flex justify-content-left gap-2">
                        <img src={totalConsultationIcon} alt="" />
                        <p className="consultation-card-title" style={{ margin: 0 }}>Total Cons.</p>
                    </div>
                    <h3 className="fw-bold mb-0 fs-6" style={{ marginTop: "5px" }}>{consultationMonitoring?.totalConsultation}</h3>
                    <small className="todays-count">Today : <span>{consultationMonitoring?.todayConsultation}</span></small>
                </div>
                <div className="consultation-card">
                    <div className="d-flex justify-content-left gap-2">
                        <img src={completeConsultationIcon} alt="" />
                        <p className="text-success consultation-card-title" style={{ margin: 0 }}>Total Complete Cons.</p>
                    </div>
                    <h3 className="fw-bold mb-0 text-success fs-6" style={{ marginTop: "5px" }}>{consultationMonitoring?.completeConsultation}</h3>
                    <small className="todays-count">Completed Today : <span>{consultationMonitoring?.toadyCompleteConsultation}</span></small>
                </div>
                <div className="consultation-card">
                    <div className="d-flex justify-content-left gap-2">
                        <img src={upcomingConsultationIcon} alt="" />
                        <p className="consultation-card-title" style={{ color: "#CA6500", margin: 0 }}>Total Upcoming Cons.</p>
                    </div>
                    <h3 className="fw-bold mb-0 fs-6" style={{ color: "#CA6500", marginTop: "5px" }}>{consultationMonitoring?.upComingConsultation}</h3>
                    <small className="todays-count">Pending Today : <span>{consultationMonitoring?.todayUpComingConsultation}</span></small>
                </div>
                <div className="consultation-card">
                    <div className="d-flex justify-content-left gap-2">
                        <img src={cancelConsultationIcon} alt="" />
                        <p className="text-danger consultation-card-title" style={{ margin: 0 }}>Total Cancelled Cons.</p>
                    </div>
                    <h3 className="fw-bold mb-0 text-danger fs-6" style={{ marginTop: "5px" }}>{consultationMonitoring?.cancelledConsultation}</h3>
                    <small className="todays-count">Cancelled Today : <span>{consultationMonitoring?.todayCancelledConsultation}</span></small>
                </div>
                <div className="consultation-card">
                    <div className="d-flex justify-content-left gap-2">
                        <img src={closeIcon} alt="" />
                        <p className="consultation-card-title" style={{ margin: 0 }}>Auto Cancelled Cons.</p>
                    </div>
                    <h3 className="fw-bold mb-0 fs-6" style={{ marginTop: "5px" }}>{consultationMonitoring?.autoCancelledConsultation}</h3>
                    <small className="todays-count">Today Cancelled : <span>{consultationMonitoring?.todayAutoCancelledConsultation}</span></small>
                </div>
                <div className="consultation-card">
                    <div className="d-flex justify-content-left gap-2">
                        <img src={consultationAmountIcon} alt="" />
                        <p className="consultation-card-title" style={{ margin: 0 }}>Total Cons. Amount</p>
                    </div>
                    <h3 className="fw-bold mb-0 fs-6" style={{ marginTop: "5px" }}>{formatAmount(consultationMonitoring?.totalConsultationAmount)}</h3>
                    <small className="todays-count">Today Amount : <span>{consultationMonitoring?.todayConsultationAmount}</span></small>
                </div>
                <div className="consultation-card">
                    <div className="d-flex justify-content-left gap-2">
                        <img src={gstIcon} alt="" />
                        <p className="consultation-card-title" style={{ margin: 0 }}>Gst Amount</p>
                    </div>
                    <h3 className="fw-bold mb-0 fs-6" style={{ marginTop: "5px" }}>{formatAmount(consultationMonitoring?.totalConsultationGstAmount)}</h3>
                    <small className="todays-count">Today Gst : <span>{consultationMonitoring?.todayConsultationGstAmount}</span></small>
                </div>
                <div className="consultation-card">
                    <div className="d-flex justify-content-left gap-2">
                        <img src={refundIcon} alt="" />
                        <p className="consultation-card-title" style={{ margin: 0 }}>Refund Amount</p>
                    </div>
                    <h3 className="fw-bold mb-0 fs-6" style={{ marginTop: "5px" }}>{formatAmount(consultationMonitoring?.totalRefundAmount)}</h3>
                    <small className="todays-count">Today Refund Amount : <span>{formatAmount(consultationMonitoring?.todayRefundAmount)}</span></small>
                </div>
                <div className="consultation-card">
                    <div className="d-flex justify-content-left gap-2">
                        <img src={revenueIcon} alt="" />
                        <p className="consultation-card-title" style={{ margin: 0 }}>Revenue</p>
                    </div>
                    <h3 className="fw-bold mb-0 fs-6" style={{ marginTop: "5px" }}>{formatAmount(consultationMonitoring?.totalRevenue)}</h3>
                    <small className="todays-count">Today Revenue : <span>{consultationMonitoring?.todayRevenue}</span></small>
                </div>
                <div className="consultation-card">
                    <div className="d-flex justify-content-left gap-2">
                        <img src={lawyerFees} alt="" />
                        <p className="consultation-card-title" style={{ margin: 0 }}>Total Advocate Fee</p>
                    </div>
                    <h3 className="fw-bold mb-0 fs-6" style={{ marginTop: "5px" }}>{formatAmount(consultationMonitoring?.totalLawyerFee)}</h3>
                    <small className="todays-count">Today Advocate Fee : <span>{formatAmount(consultationMonitoring?.todayLawyerFee)}</span></small>
                </div>
            </div>
        </div>
        <div>
            <table className="report-table">
                <thead>
                    <tr>
                        <th colSpan={2}>SNo</th>
                        <th colSpan={4}>Date</th>
                        <th colSpan={3}>Cons. ID</th>
                        <th colSpan={5}>Customer Name/ID</th>
                        <th colSpan={5}>Cust Contact Details</th>
                        <th colSpan={5}>Advocate Name/ID</th>
                        <th colSpan={5}>Advocate Contact Details</th>
                        <th colSpan={2}>Cons.Time</th>
                        <th colSpan={3}>Start Time</th>
                        <th colSpan={3}>End Time</th>
                        <th colSpan={5}>Specialization</th>
                        <th colSpan={5}>Add on</th>
                        {
                            activeTab === "COMPLETED" ? <>
                                <th colSpan={3}>Extented Time</th>
                                <th colSpan={3}>Fees</th>
                                <th colSpan={5}>Record</th>
                                <th colSpan={5}>Complaint Status</th>
                                <th colSpan={5}>Feedback</th>
                            </> : activeTab === "LOW_RATING" ? <>
                                <th colSpan={3}>Extented Time</th>
                                <th colSpan={3}>Fees</th>
                                <th colSpan={5}>Record</th>
                                <th colSpan={3}>Rating</th>
                                <th colSpan={5}>Reason</th>
                            </> : activeTab === "CANCELLED" ? <>
                                <th colSpan={5}>Reason For Cancellation</th>
                            </> : activeTab === "AUTO_CANCELLED" ? <>
                                <th colSpan={5}>AutoCancelled By</th>
                            </> : <>
                            </>
                        }
                    </tr>
                </thead>
                <tbody>
                    {data?.map((detail, index) => {
                        const extendList = detail?.extendConsultionDetailsList || [];
                        const totalExtendMin = extendList?.reduce((sum, extenTime) => {
                            const val = Number(extenTime?.extendMin) || 0;
                            return sum + val;
                        }, 0);
                        const addOns = detail?.consultationPaymentDetails?.addOnList?.map(addonInfo => addonInfo?.addOn) || [];
                        const customerInformation = detail?.customerResponse;
                        const lawyerInformation = detail?.lawyerResponse
                        return <tr key={index}>
                            <td colSpan={2}>{index + 1}</td>
                            <td colSpan={4}>{detail?.consultationDate ? dayjs(detail?.consultationDate)?.format("DD-MM-YYYY") : "Nil"}</td>
                            <td colSpan={3}>{detail?.consultationNo || "Nil"}</td>
                            <td colSpan={5}>
                                <div>
                                    <p style={{ padding: 0, margin: 0 }}>{customerInformation?.firstName || "Nil"} {customerInformation?.middleName || ""} {customerInformation?.lastName || ""}</p>
                                    <small style={{ color: "#ABABAB" }}>{customerInformation?.customerNo || "Nil"}</small>
                                </div>
                            </td>
                            <td colSpan={5}>
                                <div>
                                    <p style={{ padding: 0, margin: 0 }}>{customerInformation?.mobileNumber ? formatPhoneNumber(customerInformation?.mobileNumber) : "Nil"}</p>
                                    <small style={{ color: "#ABABAB" }}>{customerInformation?.email || "Nil"}</small>
                                </div>
                            </td>
                            <td colSpan={5}>
                                <div>
                                    <p style={{ padding: 0, margin: 0 }}>{lawyerInformation?.firstName || "Nil"} {lawyerInformation?.middleName || ""} {lawyerInformation?.lastName || ""}</p>
                                    <small style={{ color: "#ABABAB" }}>{lawyerInformation?.lawyerNo || "Nil"}</small>
                                </div>
                            </td>
                            <td colSpan={5}>
                                <div>
                                    <p style={{ padding: 0, margin: 0 }}>{lawyerInformation?.mobileNumber ? formatPhoneNumber(lawyerInformation?.mobileNumber) : "Nil"}</p>
                                    <small>{lawyerInformation?.email || "Nil"}</small>
                                </div>
                            </td>
                            <td colSpan={2}>{detail?.consultationTime || "Nil"}</td>
                            <td colSpan={3}>{detail?.consultationStartTime ? dayjs(detail?.consultationStartTime)?.format("hh:mm A") : "Nil"}</td>
                            <td colSpan={3}>{detail?.consultationEndTime ? dayjs(detail?.consultationEndTime)?.format("hh:mm A") : "Nil"}</td>
                            <td colSpan={5}>{lawyerInformation?.specialization?.join(",") || "Nil"}</td>
                            <td colSpan={5}>{addOns?.join(", ") || "Nil"}</td>
                            {
                                activeTab === "COMPLETED" ? <>
                                    <td colSpan={3}>{totalExtendMin}</td>
                                    <td colSpan={3}>&#8377;{detail?.fees ? formatAmount(detail?.fees) : "0"}</td>
                                    <td colSpan={5}>
                                        {
                                            detail?.record ? <div className="success-status"><p>Recorded</p></div> : <div className="danger-status"><p>Not Recorded</p></div>
                                        }
                                    </td>
                                    <td colSpan={5}>
                                        {
                                            detail?.consultationStatus && detail?.consultationStatus === "COMPLETED" ? <div className="success-status"><p>Completed</p></div> : detail?.consultationStatus && detail?.consultationStatus === "PENDING" ? <div className="pending-status"><p>Pending</p></div> : "Nil"
                                        }
                                    </td>
                                    <td colSpan={5}>{detail?.feedback?.feedback || "Nil"}</td>
                                </> : activeTab === "LOW_RATING" ? <>
                                    <td colSpan={3}>{totalExtendMin}</td>
                                    <td colSpan={3}>&#8377;{detail?.consultationPaymentDetails?.totalConsultationAmount || detail?.fees ? formatAmount(detail?.consultationPaymentDetails?.totalConsultationAmount || detail?.fees) : "0"}</td>
                                    <td colSpan={5}>
                                        {
                                            detail?.recordDetail?.record ? <div className="success-status"><p>Recorded</p></div> : <div className="danger-status"><p>Not Recorded</p></div>
                                        }
                                    </td>
                                    <td colSpan={3}>{detail?.feedback?.rating || "Nil"}</td>
                                    <td colSpan={5}>{detail?.feedback?.ratingReason || "Nil"}</td>
                                </> : activeTab === "CANCELLED" ? <>
                                    <td colSpan={5}>{detail?.cancelDetails?.reason || "Nil"}</td>
                                </> : activeTab === "AUTO_CANCELLED" ? <>
                                    <td colSpan={5}>{detail?.cancelDetails?.autoCancelledByName || "Nil"}</td>
                                </> : <>
                                </>
                            }
                        </tr>
                    })}
                </tbody>
            </table>
        </div>
    </div>
};
export default ConsultationMonitoringReport